'use client';
import { useContext, memo } from 'react';
import { ModalID, useModal } from '@repo/ui/src/modules/UI';
import VideoThumbnail from '@repo/ui/src/components/VideoThumbnail';
import PlaylistContext from './_PlaylistContext';

import type { PlaylistItem } from '@repo/ui/src/types/youtubeLink';

interface GridItemProps {
  item: PlaylistItem;
}

const getYoutubeId = (contentUrl: string): string =>
  contentUrl.split('https://www.youtube.com/watch?v=').pop() ?? '';

const TraegerTVListItem = ({ item }: GridItemProps) => {
  const { id, title, thumbnailUrl, description, youtubeLink } = item || {};
  const { push } = useModal(ModalID.video);

  const playlistItems = useContext(PlaylistContext);

  return (
    <div className="h-full p-4">
      <div>
        <VideoThumbnail
          title={title}
          imgUrl={thumbnailUrl}
          duration={youtubeLink?.duration}
          onClick={() =>
            push({
              youtubeLink: {
                ...youtubeLink,
                youtubeId: getYoutubeId(youtubeLink.contentUrl),
                description: youtubeLink.description ? youtubeLink.description : description,
              },
              playlistItems: playlistItems
                ?.filter((x) => x.id !== id)
                ?.map((x) => ({
                  ...x,
                  youtubeLink: {
                    ...x.youtubeLink,
                    youtubeId: getYoutubeId(x.youtubeLink.contentUrl),
                    description: x.youtubeLink?.description
                      ? x.youtubeLink?.description
                      : x.description,
                  },
                })),
            })
          }
        />
        {title && <h6 className="text-left text-white my-4 tra-text-web-heading-7">{title}</h6>}
      </div>
      {description && <p className="text-white">{description}</p>}
    </div>
  );
};

export default memo(TraegerTVListItem);
